// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}

/*statuts rond colorés*/
span.round {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: block;
  margin: auto;
}

span.red-round {
  background-color: #fd5353;
}

span.green-round {
  background-color: #09bd72;
}

span.orange-round {
  background-color: #fb6d3b;
}

.popup-beige {
  background-color: beige;
  width: 200px;
  height: 100px;
}

.bg-none-input {
  background-color: transparent !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

/*
* Dashboard design
*/
.rotate {
  transform: rotate(180deg);
  transform-origin: center;
}

.dashboard .general-stats {
  flex-wrap: wrap;
  justify-content: center;
  /*margin-top: 40px;*/
  /*margin-bottom: 40px;*/
}

.dashboard .general-stats .item {
  box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);
  border-radius: 20px;
  /*width: 339px;*/
  height: 270px;
  margin: 0.5 0.5em;
  position: relative;
  flex: 1 1;
  transition: transform 0.3s ease-in-out;
}

.dashboard .general-stats .clicked {
  /*transform: scale(1.1);*/
  transform: translateY(10%);
}

.dashboard .general-stats .item:first-child {
  margin-left: 0;
}

.dashboard .general-stats .item:last-child {
  margin-right: 0;
}

.dashboard .general-stats .item:even {
  margin-right: 0;
}

.dashboard .general-stats .item * {
  color: white;
  font-style: normal;
}

.dashboard .general-stats .item h3 {
  font-weight: 500;
  font-size: 20px;
}

.dashboard .general-stats .item h1 {
  font-weight: 600;
  /*font-size: 30px;*/
  margin-bottom: 12px;
}

.dashboard .general-stats .item > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
}

.dashboard .general-stats .item ul li {
  margin-bottom: 0.5em;
}

.dashboard .general-stats .item ul li:before {
  content: "";
  height: 10px;
  width: 10px;
  background-color: white;
  border-radius: 50%;
  align-self: center;
  margin-right: 15px;
  margin-bottom: 3px;
}

.dashboard .general-stats .item ul li span {
  /*font-size: 14px;*/
}

.dashboard .general-stats .item ul li span:last-child {
  font-style: normal;
  font-weight: bold;
  /*font-size: 18px;*/
  line-height: 25px;
}

.dashboard .arrow {
  position: absolute;
  right: 10px;
  bottom: 1.1rem;
  font-size: 50px;
  cursor: pointer;
}

.graphs {
  flex-wrap: wrap;
  margin-top: 40px;
  padding: 0;
}

.graphs .item {
  background: #ffffff;
  mix-blend-mode: normal;
  box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);
  border-radius: 20px;
  padding: 30px;
  position: relative;
  overflow-y: auto;
}

.graphs .item:first-child {
  width: calc(55% - 40px);
  margin-right: 40px;
}

.graphs .item:last-child {
  width: 45%;
}

.graphs .item .parent-div {
  min-width: 500px;
}

.graphs .item .text {
  margin-bottom: 20px;
}

.graphs .item h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  color: #171b1e;
}

.graphs .item h6 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #717579;
}

.depenses table thead {
  background: #ff8a1f;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 30px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 12px;
  padding: 10px 0;
}

.recettes table thead {
  background: #c2027d;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 30px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 12px;
  padding: 10px 0;
}

.msg-table table thead {
  background: #30006d;
  font-style: normal;
  font-weight: bold;
  /*font-size: 22px;*/
  line-height: 30px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0 12px;
  padding: 10px 0;
}

.mt-0 {
  margin-top: 0 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.operations .parent-table,
.recettes .parent-table,
.depenses .parent-table {
  /*overflow-y: auto;*/
  margin-top: 30px;
  padding-bottom: 15px;
}

.operations .default-text,
.recettes .default-text,
.depenses .default-text {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
}

.operations table,
.recettes table,
.depenses table,
.msg-table table {
  border-radius: 20px 20px 0 0;
  mix-blend-mode: normal;
  box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);
  /*min-width: 1200px;*/
}

/*mobile*/
.content-table-mobile .operations table,
.content-table-mobile .recettes table,
.content-table-mobile .depenses table {
  min-width: initial !important;
}

.content-table-mobile .depenses table thead tr th:nth-child(2) {
  width: inherit !important;
}

.menu-admins-n {
  width: 100px;
  border: 1px solid red;
}

/*fin mobile*/
form#registration div input {
  /*height: 26px !important;*/
  /*padding: 0;*/
}

.width-100 {
  width: 100%;
}

.w-40 {
  width: 10rem;
}

.width-25 {
  width: 25%;
}

form#create-profile div input {
  /*height: 26px !important;*/
  /*padding: 0;*/
}

form#registration input,
form#create-profile input,
form#create-bank input,
form#create-person input {
  color: black;
}

/*formulaire inscription*/
form#registration,
form#create-profile,
form#create-bank,
form#create-person,
form#employe-infos {
  padding-left: 16px;
}

/*Formulaire mes infos*/
form#mes-infos-form,
form#mon-profil-form,
form#bank-account-infos,
form#person-infos,
form#employe-infos {
  padding-left: 16px;
}

.img-mail {
  width: 50px;
  height: 50px;
}

.img-notification {
  width: 24px;
  height: 26px;
}

.img-mailicon,
.img-mailround {
  width: 29px;
  height: 26px;
  max-width: inherit;
}

.notification-section {
  gap: 40px;
}

.bordureTd {
  border-bottom: 1.5px solid #d7d7d7;
}

.bordureTopTd {
  border-top: 1.5px solid #d7d7d7;
}

.infos-register {
  font-size: small;
}

.min-w-full {
  min-width: 100% !important;
}

.w-9-12 {
  width: 75%;
}

.inscrire {
  margin-left: 281px;
}

.bg-violetClaire {
  background-color: #faf9ff !important;
}

.bg-grisClaire {
  background-color: #f5f5f5;
}

.compte-bancaire {
  color: #171b1e;
}

.select-violet {
  color: #6957b4;
  background-color: #e3dcfd;
}

#menu-bbb {
  /*height: 15rem;*/
}

#menu-bbb,
#mon-compte {
  width: 180px;
}

#menu-bbb ul li a,
#mon-compte ul li a {
  width: 100%;
  padding: 10px;
  display: block;
}

.border-input-register {
  border-right: 8px solid white;
}

.colors span {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 0 3px;
  display: block;
}

.msg-table th {
  /*padding: 0 0.2rem 0 0.2rem !important;*/
}

.msg-table .vente th {
  padding: 1rem;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.msg-table .vente th div {
  /*padding: 1rem !important;*/
  width: 100%;
  justify-content: center;
}

.msg-table tr > td {
  padding: 1rem;
}

.padding-0 {
  padding: 0 !important;
}

.bg-grisbleu {
  background-color: #f2f5ff;
}

.width-50 {
  width: 50%;
}

#new-manual-row table thead tr th div {
  padding: 0.7rem;
}

.checkbox-admin input {
  width: inherit !important;
  margin: 1rem !important;
}

.padding-last-th {
  padding-right: 3rem !important;
}

#new-manual-row table thead tr th {
}

.vertBouton {
  background-color: #09bd72;
}

.uppercase {
  text-transform: uppercase !important;
}

.ml-16px {
  margin-left: 16px;
}

#menu-bbb ul li a:hover,
#mon-compte ul li a:hover {
  background-color: #f3f0ff;
  color: #671c91;
  border-radius: 5px;
}

form#registration,
form#create-profile {
  width: 100%;
}

.bg-form-blue {
  background-color: #f2f5ff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.registration-row-admin-n:nth-of-type(odd) {
  background-color: #e9ecf5 !important;
}

.registration-row-admin-n:nth-of-type(even) {
  background-color: #cfd5eb !important;
}

.registration-row:nth-of-type(odd) {
  background-color: #f2f5ff !important;
}

.registration-row-even:nth-of-type(even) {
  background-color: #f2f5ff !important;
}

.operations table tbody input,
.recettes table tbody input,
.depenses table tbody input {
  width: 100%;
  margin: 0;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid darkgray;
}

.operations table tbody .modify td:nth-child(6) span,
.recettes table tbody .modify td:nth-child(6) span,
.depenses table tbody .modify td:nth-child(6) span {
  margin: 0 !important;
}

.operations table tbody:nth-child(4n),
.operations table tbody:nth-child(4n + 1) {
  background-color: #f2f5ff;
}

.bleu-bg {
  background-color: #30006d;
}

.operations table thead {
  background: #30006d;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 30px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 12px;
  padding: 10px 0;
}

.operations table thead tr,
.recettes table thead tr,
.depenses table thead tr,
.msg-table table thead tr {
  height: 100px;
}

.operations table thead tr th,
.recettes table thead tr th,
.depenses table thead tr th,
.msg-table table thead tr th {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

form#mes-infos-form tr > td:first-child,
form#mon-profil-form tr > td:first-child {
  text-transform: uppercase;
  margin-right: 1rem;
}

form#mes-infos-form button[type="submit"]:hover,
form#mon-profil-form button[type="submit"]:hover {
  background-color: rgba(90, 69, 170, 0.8);
  color: white;
}

.operations table thead tr th:nth-child(1) {
  width: 8%;
}

.recettes table thead tr th:nth-child(1),
.depenses table thead tr th:nth-child(1) {
  width: 30%;
}

.recette table thead tr th:nth-child(2),
.depenses table thead tr th:nth-child(2) {
  width: 10%;
}

.operations table thead tr th:nth-child(2) {
  /*width: 30%;*/
}

.operations-mobile table thead tr th:nth-child(2) {
  width: inherit;
}

.operations-mobile table {
  min-width: inherit !important;
}

.operations table thead tr th:nth-child(3) {
  /*width: 5%;*/
}

.operations table thead tr th:nth-child(4) {
  /*width: 10%;*/
}

.operations table thead tr th:nth-child(5),
.recettes table thead tr th:nth-child(5) {
  /*width: 10%;*/
}

.operations table thead tr th:nth-child(6) {
  /*width: 10%;*/
}

.operations table thead tr th:nth-child(7),
.operations table thead tr th:nth-child(8) {
  /*width: 13.5%;*/
}

.operations table thead tr th:nth-child(7) .icons > div,
.operations table thead tr th:nth-child(8) .icons > div {
  left: 50%;
  transform: translateX(-50%);
}

.operations table thead tr th:nth-child(7),
.operations table thead tr th:nth-child(8),
.operations table thead tr th .text span {
  font-style: normal;
  font-weight: bold;
  /*font-size: 18px;*/
  line-height: 30px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.operations table thead tr th .label {
  font-style: normal;
  font-weight: bold;
  /*font-size: 18px;*/
  line-height: 30px;
  color: #ffffff;
}

.operations table thead tr th .text svg {
  font-size: 35px;
}

.operations table thead tr th .text > *:nth-child(2) {
  transform: translate(-2px, -3px);
}

.operations table thead tr th .text svg:last-child {
  transform: translate(-80%, 13%);
}

.operations table thead tr th .icons > div {
  position: absolute;
  top: 0;
  left: 0px;
}

.operations table thead tr th .icons p {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 19px;
  color: #ffffff;
  padding-left: 21px;
  position: relative;
}

.operations table thead tr th .icons p span {
  content: "+";
  background-color: white;
  border: 1px solid #8a46fb;
  color: #8a46fb;
  display: inline-block;
  width: 18px;
  height: 18px;
  text-align: center;
  border-radius: 50%;
  line-height: 16px;
  font-size: 20px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.operations table thead tr th .icons ul li {
  margin-right: 5px;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  box-sizing: content-box;
  color: white;
}

.operations table thead tr th .icons ul li.green {
  background: #09bd72;
  border: 2px solid #09bd72;
}

.operations table thead tr th .icons ul li.orange {
  background: #f87c22;
  border: 2px solid #f87c22;
}

.operations table thead tr th .icons ul li.red {
  background: #fd5353;
  border: 2px solid #fd5353;
}

.operations table thead tr th .icons ul li.green-border {
  background: white;
  color: #09bd72;
  border: 2px solid #09bd72;
}

.operations table thead tr th .icons ul li.orange-border {
  background: white;
  color: #f87c22;
  border: 2px solid #f87c22;
}

.operations table thead tr th .icons ul li.red-border {
  background: white;
  color: #fd5353;
  border: 2px solid #fd5353;
}

.operations table tbody.sub-rows {
  display: none;
  opacity: 0;
  transition: opacity 1s 1s ease-in-out;
}

.operations table tbody.show-sub-rows {
  display: table-row-group;
  opacity: 1;
}

.operations table tbody tr td,
.msg-table table tbody tr td {
  height: 90px;
}

.operations table tbody tr td:nth-child(2) h4 {
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 19px;
  color: #fd5353;
}

.operations table tbody tr td:nth-child(2) h4 span {
  margin-right: 5px;
}

.operations table tbody tr td:nth-child(2) h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
}

.operations table tbody tr td:nth-child(2) > div {
  width: 100%;
}

/*.operations table tbody tr td:nth-child(2) > div > div{*/
/*    margin-left: auto;*/
/*    margin-right: 30px;*/
/*}*/
.p-0 {
  padding: 0 !important;
}

.rounded-r-none {
  border-top-right-radius: 0px !important;
}

.except-last-td > td.actions,
.except-last-th > th.actions {
  background-color: white;
}

.messages .list-msg .add,
.btn-add {
  position: absolute;
  top: 0;
  right: 0;
  width: 55px;
  height: 55px;
  line-height: 48px;
  text-align: center;
  font-size: 46px;
  background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);
  border-radius: 20px;
  color: white;
  transform: translate(22%, -50%);
}

.operations table tbody tr td:nth-child(2) svg,
.operations table tbody tr td:nth-child(2) > div {
  align-self: center;
}

.operations table tbody tr td:nth-child(2) > div svg {
  margin-left: 25px;
  margin-top: -2px;
  cursor: pointer;
}

.operations table tbody tr td:nth-child(3) > div {
  position: relative;
  display: inline-block;
}

.operations table tbody tr td:nth-child(3) svg {
  color: #717579;
  font-size: 35px;
}

.operations table tbody tr td:nth-child(3) span.unread {
  background: #ff9d42;
}

.operations table tbody tr td:nth-child(3) span.read {
  background: #818181;
}

.operations table tbody tr td .top-icon {
  position: absolute;
  border: 3px solid #fbfbfb;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  width: 28px;
  height: 28px;
  right: 0;
  top: 0;
  border-radius: 50%;
  text-align: center;
  transform: translate(50%, -50%);
  line-height: 23px;
}

.operations table tbody tr td:nth-child(6) span:nth-child(2) {
  font-style: normal;
  font-weight: 300;
  /*font-size: 16px;*/
  line-height: 22px;
  color: #b3b3b3;
  margin-left: 10px;
}

.operations table tbody tr td:nth-child(7) svg {
  color: #818181;
  font-size: 30px;
}

.operations table tbody tr td:nth-child(7) span {
  width: 20px;
  height: 20px;
  transform: translate(15%, -50%);
}

.operations table tbody tr td:nth-child(7) span.green {
  background-color: #09bd72;
}

.operations table tbody tr td:nth-child(7) span.orange {
  background-color: #f87c22;
}

.operations table tbody tr td:nth-child(7) span.red {
  background-color: #fd5353;
}

.operations table tbody tr td:nth-child(8) > div {
  cursor: pointer;
}

.operations table tbody tr td:nth-child(8) > div span {
  color: white;
}

.operations table tbody tr td:nth-child(8) > div.icon {
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  margin: 0 auto;
}

.operations table tbody tr td:nth-child(8) > div.text {
  background: #fd5353;
  border-radius: 20px;
  width: 100px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
}

.operations table tbody tr td:nth-child(8) > div.green {
  background: #09bd72;
}

.operations table tbody tr td:nth-child(8) > div.orange {
  background: #f87c22;
}

.operations table tbody tr td:nth-child(8) > div.red {
  background: #fd5353;
}

.operations table tbody tr td:nth-child(8) svg {
  color: white;
}

.operations tbody.sub-rows tr:last-child {
  border-bottom: none;
}

.operations tbody.sub-rows tr:last-child td:first-child {
  border-bottom-left-radius: 20px;
}

.operations tbody.sub-rows tr:last-child td:last-child {
  border-bottom-right-radius: 20px;
}

.operations tbody.sub-rows tr:last-child td {
  border: none;
}

.operations .btn-add a {
  background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);
  border-radius: 20px;
  height: 60px;
  width: 60px;
  display: block;
  text-align: center;
  line-height: 51px;
  font-size: 51px;
  color: white;
  margin-left: auto;
  margin-top: 14px;
  cursor: pointer;
}

.recette {
  margin-top: 40px;
  box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);
  border-radius: 20px;
  overflow-y: auto;
}

.recette .parent-recette {
  min-width: 1100px;
}

.recette .title {
  background: #30006d;
  padding: 30px;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
}

.recette h2 {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  color: #ffffff;
}

.recette .table {
  background: #ffffff;
  width: 100%;
}

.recette .open {
  box-shadow: 0px 3px 6px rgb(86 86 86 / 25%);
  border-radius: 0px 0px 20px 20px;
  padding-bottom: 17px;
}

.recette .table .summary {
  border-bottom: 1px solid #d7d7d7;
}

.recette .table .border-0 {
  border: none !important;
}

.recette .table .summary svg {
  cursor: pointer;
}

.recette .table .summary ul {
  margin: 20px 30px;
}

.recette .table .summary ul li {
  flex: 1 1;
}

.recette .table:nth-child(odd) {
  background-color: #f2f5ff;
}

.recette .table .table-title {
  margin: 20px 30px 16px;
}

.recette .table .hide {
  display: none;
}

.recette .table .table-title h4 {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #717579;
}

.recette .table .table-title svg {
  margin: 0 0 0 auto;
  cursor: pointer;
}

.recette .table thead tr {
  text-align: left;
  border-bottom: 1px solid #d7d7d7;
}

.recette .table thead tr th {
  padding-bottom: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #171b1e;
}

.recette .table tr td {
  padding-top: 16px;
  width: calc(100% / 12);
}

.recette .table tr th:first-child,
.recette .table tr td:first-child {
  padding-left: 30px;
}

/* START RESPONSIVE PART */

@media (max-width: 1300px) {
  .dashboard .general-stats .item {
    /*flex: none;*/
  }

  .dashboard .general-stats .item:nth-child(odd) {
    margin-left: 0;
  }

  .dashboard .general-stats .item:nth-child(even) {
    margin-right: 0;
  }

  .graphs .item {
    width: 100% !important;
  }
  .chartClass {
    width: 100% !important;
  }
  .parent-div {
    padding-top: 46px;
  }
  .graphs {
    position: relative;
  }

  .switchBtn {
    position: absolute;
    top: 0;
    left: 30px;
    width: auto;
  }
}

@media (max-width: 1400px) {
  .resize-text {
    font-size: 12px !important;
  }

  .dashboard .general-stats .item {
    height: 258px;
  }

  .dashboard .general-stats .item h1 {
    margin-bottom: 3px;
  }

  .dashboard .general-stats .item ul li {
    margin-bottom: 0;
  }

  .dashboard .general-stats .item ul li:before {
    margin-right: 5px;
    margin-bottom: 6px;
  }

  .dashboard .general-stats .item ul li span {
    /*font-size: 14px;*/
  }

  .dashboard .general-stats .item ul li span:last-child {
    /*font-size: 15px;*/
  }

  .operations table thead tr th .icons ul li.green-border {
    background: white;
    color: #09bd72;
    border: 2px solid #09bd72;
  }
  .operations table thead tr th .icons ul li {
    margin-right: 5px;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    line-height: 16px;
    text-align: center;
    font-size: 8px;
    box-sizing: content-box;
  }
}

@media (max-width: 1550px) {
  .dashboard .general-stats .item ul li:before {
    margin-right: 5px;
  }
}

@media (max-width: 1000px) {
  .dashboard .general-stats .item {
    margin-right: 0.5em !important;
    margin-left: 0.5em !important;
  }
}

@media (max-width: 700px) {
  .graphs {
    padding: 0;
  }

  .graphs .item {
    padding: 20px;
  }
}

@media (max-width: 760px) {
  .none-mobile {
    display: none;
  }
}

@media (max-width: 768px) {
  /*.client-info{*/
  /*    padding-left: inherit;*/
  /*}*/
}

@media (max-width: 999px) {
  .client-info {
    padding-left: inherit;
  }
}

@media (min-width: 1000px) {
  #derouler {
    padding-left: 367px;
  }
}

@media (max-width: 1600px) {
  .periode-aff {
    flex-wrap: wrap;
  }

  .periode-aff > div {
    width: 100%;
    margin-right: 0 !important;
    /*margin-bottom: 10px;*/
  }

  .periode-aff .uppercase {
    margin-right: 5px;
  }
}

.react-resizable-handle {
	bottom: auto !important;
	right: -15px !important;
	background-size: cover;
}

#resizable-element div:first-child::-webkit-scrollbar-thumb {
	background-color: #5a45aa80;
	border: 4px solid transparent;
	border-radius: 0.5rem;
	background-clip: padding-box;
}

#resizable-element div:first-child::-webkit-scrollbar {
	width: 18px;
}

.export-account .radio-label {
  padding: .7rem 2rem;
  border-radius: .5rem;
  color: #FFF;
  cursor: pointer;
  font-weight: bold;
  background-color: rgb(162 143 235 / var(--tw-bg-opacity));
}

.export-account input[type="radio"] {
  display: none;
}

.export-account input[type="radio"]:checked + .radio-label {
  background-color: rgb(101 38 158 / var(--tw-bg-opacity));
  color: white;
  font-weight: bold;
}

table.operations-table > tbody > tr,
table.documents-table > tbody > tr {
  background-color: transparent;
  transition: background-color 2s ease;
}

table.operations-table > tbody > tr.highlighted-row,
table.documents-table > tbody > tr.highlighted-row {
  background-color: lightyellow !important;
}

#affectation-operation tfoot.ocr-reprocessed,
#affectation-operation tfoot.ocr-reprocessed input,
table.affectations-piece tfoot.ocr-reprocessed, 
table.affectations-piece tfoot.ocr-reprocessed input {
  background: #e2fbbc;
}

#affectation-operation tfoot.ocr-reprocessed tr td,
table.affectations-piece tfoot.ocr-reprocessed tr td {
  color: rgb(29 153 74);
  font-weight: bold;
}

.scan-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 255, 0, 0.1) 0%,
    rgba(0, 255, 0, 0.4) 50%,
    rgba(0, 255, 0, 0.1) 100%
  );
  animation: scan 2s linear infinite;
}

@keyframes scan {
  0% {
    top: -100%;
  }
  100% {
    top: 100%;
  }
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.is-corrected {
  font-weight: bold;
  color: #2d986c;
}

/* START: Custom Checkbox Type 1 */
.checkbox-type1 input[type="checkbox"] {
  display: none;
}

.checkbox-type1 .checkbox-icon {
  width: 23px;
  height: 23px;
  background: #FFF;
  border: 2px solid #30006D;
  border-radius: 8px;
  display: inline-block;
  position: relative;
  margin-right: 8px;
  cursor: pointer;
  box-sizing: border-box;
}

.checkbox-type1 .checkbox-icon .checkmark {
  position: absolute;
  top: -3px;
  right: -5px;
  display: none;
}

.checkbox-type1 input[type="checkbox"]:checked + .checkbox-icon .checkmark {
  display: block;
}
/* END: Custom Checkbox Type 1 */

.documents-suggestions {
  width: 65%;
}

.document-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.document-row .document {
  flex: 1 1;
  padding: .6rem;
  border-radius: 10px;
  margin-bottom: 1rem;
  background: rgb(242 245 255 / var(--tw-bg-opacity));
}

.document-row table {
  width: 100%;
  table-layout: fixed;
  box-shadow: none !important;
}

.document-row table thead tr td {
  font-size: 14px;
  color: #717579;
}

.document-row table thead tr td.date,
.document-row table thead tr td.label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-row table thead tr td.date {
  width: 120px;
}

.document-row table thead tr td.label {
  width: 270px;
}

.document-row table tr td {
  padding: 4px 7px !important;
}

.document-row table tbody tr td {
  font-size: 16px;
} 

.document-row table tbody tr td span.rate {
  color: #B3B3B3;
}

.document-row table tbody .categ,
.affect table.affectations-piece tbody .categ {
  color: #818181;
  font-size: 12px;
  font-weight: 500 !important;
}

.documents-suggestions button.other-documents {
  width: 186px;
  height: 47px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 7px;
  justify-content: space-evenly;
  background: #F2F5FF;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/dashboard.css"],"names":[],"mappings":"AAAA;;;;EAIE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;;CAEC;AACD;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,SAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;EAIE,4BAA4B;EAC5B,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,SAAS;AACT;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA,yBAAyB;AACzB;;;;;EAKE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;AACA;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,0DAA0D;AAC1D,yBAAyB;AACzB,0BAA0B;AAC1B,IAAI;AACJ;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qEAAqE;EACrE,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,MAAM;EACN,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,IAAI;AACN;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;CACC,uBAAuB;CACvB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,2BAA2B;CAC3B,6BAA6B;CAC7B,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,WAAW;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wDAAwD;EACxD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;;;;;GAKC;EACD,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA,gCAAgC;;AAEhC;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":["input:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus {\n  outline: none;\n}\n\n/*statuts rond colorés*/\nspan.round {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: block;\n  margin: auto;\n}\n\nspan.red-round {\n  background-color: #fd5353;\n}\n\nspan.green-round {\n  background-color: #09bd72;\n}\n\nspan.orange-round {\n  background-color: #fb6d3b;\n}\n\n.popup-beige {\n  background-color: beige;\n  width: 200px;\n  height: 100px;\n}\n\n.bg-none-input {\n  background-color: transparent !important;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/*\n* Dashboard design\n*/\n.rotate {\n  transform: rotate(180deg);\n  transform-origin: center;\n}\n\n.dashboard .general-stats {\n  flex-wrap: wrap;\n  justify-content: center;\n  /*margin-top: 40px;*/\n  /*margin-bottom: 40px;*/\n}\n\n.dashboard .general-stats .item {\n  box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);\n  border-radius: 20px;\n  /*width: 339px;*/\n  height: 270px;\n  margin: 0.5 0.5em;\n  position: relative;\n  flex: 1 1 0px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.dashboard .general-stats .clicked {\n  /*transform: scale(1.1);*/\n  transform: translateY(10%);\n}\n\n.dashboard .general-stats .item:first-child {\n  margin-left: 0;\n}\n\n.dashboard .general-stats .item:last-child {\n  margin-right: 0;\n}\n\n.dashboard .general-stats .item:even {\n  margin-right: 0;\n}\n\n.dashboard .general-stats .item * {\n  color: white;\n  font-style: normal;\n}\n\n.dashboard .general-stats .item h3 {\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.dashboard .general-stats .item h1 {\n  font-weight: 600;\n  /*font-size: 30px;*/\n  margin-bottom: 12px;\n}\n\n.dashboard .general-stats .item > div {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 80%;\n  height: 80%;\n}\n\n.dashboard .general-stats .item ul li {\n  margin-bottom: 0.5em;\n}\n\n.dashboard .general-stats .item ul li:before {\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  background-color: white;\n  border-radius: 50%;\n  align-self: center;\n  margin-right: 15px;\n  margin-bottom: 3px;\n}\n\n.dashboard .general-stats .item ul li span {\n  /*font-size: 14px;*/\n}\n\n.dashboard .general-stats .item ul li span:last-child {\n  font-style: normal;\n  font-weight: bold;\n  /*font-size: 18px;*/\n  line-height: 25px;\n}\n\n.dashboard .arrow {\n  position: absolute;\n  right: 10px;\n  bottom: 1.1rem;\n  font-size: 50px;\n  cursor: pointer;\n}\n\n.graphs {\n  flex-wrap: wrap;\n  margin-top: 40px;\n  padding: 0;\n}\n\n.graphs .item {\n  background: #ffffff;\n  mix-blend-mode: normal;\n  box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);\n  border-radius: 20px;\n  padding: 30px;\n  position: relative;\n  overflow-y: auto;\n}\n\n.graphs .item:first-child {\n  width: calc(55% - 40px);\n  margin-right: 40px;\n}\n\n.graphs .item:last-child {\n  width: 45%;\n}\n\n.graphs .item .parent-div {\n  min-width: 500px;\n}\n\n.graphs .item .text {\n  margin-bottom: 20px;\n}\n\n.graphs .item h3 {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 27px;\n  color: #171b1e;\n}\n\n.graphs .item h6 {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 19px;\n  color: #717579;\n}\n\n.depenses table thead {\n  background: #ff8a1f;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 30px;\n  color: #ffffff;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: 0px 12px;\n  padding: 10px 0;\n}\n\n.recettes table thead {\n  background: #c2027d;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 30px;\n  color: #ffffff;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: 0px 12px;\n  padding: 10px 0;\n}\n\n.msg-table table thead {\n  background: #30006d;\n  font-style: normal;\n  font-weight: bold;\n  /*font-size: 22px;*/\n  line-height: 30px;\n  color: #ffffff;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: 0 12px;\n  padding: 10px 0;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.operations .parent-table,\n.recettes .parent-table,\n.depenses .parent-table {\n  /*overflow-y: auto;*/\n  margin-top: 30px;\n  padding-bottom: 15px;\n}\n\n.operations .default-text,\n.recettes .default-text,\n.depenses .default-text {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #000000;\n}\n\n.operations table,\n.recettes table,\n.depenses table,\n.msg-table table {\n  border-radius: 20px 20px 0 0;\n  mix-blend-mode: normal;\n  box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);\n  /*min-width: 1200px;*/\n}\n\n/*mobile*/\n.content-table-mobile .operations table,\n.content-table-mobile .recettes table,\n.content-table-mobile .depenses table {\n  min-width: initial !important;\n}\n\n.content-table-mobile .depenses table thead tr th:nth-child(2) {\n  width: inherit !important;\n}\n\n.menu-admins-n {\n  width: 100px;\n  border: 1px solid red;\n}\n\n/*fin mobile*/\nform#registration div input {\n  /*height: 26px !important;*/\n  /*padding: 0;*/\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.w-40 {\n  width: 10rem;\n}\n\n.width-25 {\n  width: 25%;\n}\n\nform#create-profile div input {\n  /*height: 26px !important;*/\n  /*padding: 0;*/\n}\n\nform#registration input,\nform#create-profile input,\nform#create-bank input,\nform#create-person input {\n  color: black;\n}\n\n/*formulaire inscription*/\nform#registration,\nform#create-profile,\nform#create-bank,\nform#create-person,\nform#employe-infos {\n  padding-left: 16px;\n}\n\n/*Formulaire mes infos*/\nform#mes-infos-form,\nform#mon-profil-form,\nform#bank-account-infos,\nform#person-infos,\nform#employe-infos {\n  padding-left: 16px;\n}\n\n.img-mail {\n  width: 50px;\n  height: 50px;\n}\n\n.img-notification {\n  width: 24px;\n  height: 26px;\n}\n\n.img-mailicon,\n.img-mailround {\n  width: 29px;\n  height: 26px;\n  max-width: inherit;\n}\n\n.notification-section {\n  gap: 40px;\n}\n\n.bordureTd {\n  border-bottom: 1.5px solid #d7d7d7;\n}\n\n.bordureTopTd {\n  border-top: 1.5px solid #d7d7d7;\n}\n\n.infos-register {\n  font-size: small;\n}\n\n.min-w-full {\n  min-width: 100% !important;\n}\n\n.w-9-12 {\n  width: 75%;\n}\n\n.inscrire {\n  margin-left: 281px;\n}\n\n.bg-violetClaire {\n  background-color: #faf9ff !important;\n}\n\n.bg-grisClaire {\n  background-color: #f5f5f5;\n}\n\n.compte-bancaire {\n  color: #171b1e;\n}\n\n.select-violet {\n  color: #6957b4;\n  background-color: #e3dcfd;\n}\n\n#menu-bbb {\n  /*height: 15rem;*/\n}\n\n#menu-bbb,\n#mon-compte {\n  width: 180px;\n}\n\n#menu-bbb ul li a,\n#mon-compte ul li a {\n  width: 100%;\n  padding: 10px;\n  display: block;\n}\n\n.border-input-register {\n  border-right: 8px solid white;\n}\n\n.colors span {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  margin: 0 3px;\n  display: block;\n}\n\n.msg-table th {\n  /*padding: 0 0.2rem 0 0.2rem !important;*/\n}\n\n.msg-table .vente th {\n  padding: 1rem;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.msg-table .vente th div {\n  /*padding: 1rem !important;*/\n  width: 100%;\n  justify-content: center;\n}\n\n.msg-table tr > td {\n  padding: 1rem;\n}\n\n.padding-0 {\n  padding: 0 !important;\n}\n\n.bg-grisbleu {\n  background-color: #f2f5ff;\n}\n\n.width-50 {\n  width: 50%;\n}\n\n#new-manual-row table thead tr th div {\n  padding: 0.7rem;\n}\n\n.checkbox-admin input {\n  width: inherit !important;\n  margin: 1rem !important;\n}\n\n.padding-last-th {\n  padding-right: 3rem !important;\n}\n\n#new-manual-row table thead tr th {\n}\n\n.vertBouton {\n  background-color: #09bd72;\n}\n\n.uppercase {\n  text-transform: uppercase !important;\n}\n\n.ml-16px {\n  margin-left: 16px;\n}\n\n#menu-bbb ul li a:hover,\n#mon-compte ul li a:hover {\n  background-color: #f3f0ff;\n  color: #671c91;\n  border-radius: 5px;\n}\n\nform#registration,\nform#create-profile {\n  width: 100%;\n}\n\n.bg-form-blue {\n  background-color: #f2f5ff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.registration-row-admin-n:nth-of-type(odd) {\n  background-color: #e9ecf5 !important;\n}\n\n.registration-row-admin-n:nth-of-type(even) {\n  background-color: #cfd5eb !important;\n}\n\n.registration-row:nth-of-type(odd) {\n  background-color: #f2f5ff !important;\n}\n\n.registration-row-even:nth-of-type(even) {\n  background-color: #f2f5ff !important;\n}\n\n.operations table tbody input,\n.recettes table tbody input,\n.depenses table tbody input {\n  width: 100%;\n  margin: 0;\n  padding: 10px;\n  margin-bottom: 10px;\n  border: 1px solid darkgray;\n}\n\n.operations table tbody .modify td:nth-child(6) span,\n.recettes table tbody .modify td:nth-child(6) span,\n.depenses table tbody .modify td:nth-child(6) span {\n  margin: 0 !important;\n}\n\n.operations table tbody:nth-child(4n),\n.operations table tbody:nth-child(4n + 1) {\n  background-color: #f2f5ff;\n}\n\n.bleu-bg {\n  background-color: #30006d;\n}\n\n.operations table thead {\n  background: #30006d;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 30px;\n  color: #ffffff;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: 0px 12px;\n  padding: 10px 0;\n}\n\n.operations table thead tr,\n.recettes table thead tr,\n.depenses table thead tr,\n.msg-table table thead tr {\n  height: 100px;\n}\n\n.operations table thead tr th,\n.recettes table thead tr th,\n.depenses table thead tr th,\n.msg-table table thead tr th {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n\nform#mes-infos-form tr > td:first-child,\nform#mon-profil-form tr > td:first-child {\n  text-transform: uppercase;\n  margin-right: 1rem;\n}\n\nform#mes-infos-form button[type=\"submit\"]:hover,\nform#mon-profil-form button[type=\"submit\"]:hover {\n  background-color: rgba(90, 69, 170, 0.8);\n  color: white;\n}\n\n.operations table thead tr th:nth-child(1) {\n  width: 8%;\n}\n\n.recettes table thead tr th:nth-child(1),\n.depenses table thead tr th:nth-child(1) {\n  width: 30%;\n}\n\n.recette table thead tr th:nth-child(2),\n.depenses table thead tr th:nth-child(2) {\n  width: 10%;\n}\n\n.operations table thead tr th:nth-child(2) {\n  /*width: 30%;*/\n}\n\n.operations-mobile table thead tr th:nth-child(2) {\n  width: inherit;\n}\n\n.operations-mobile table {\n  min-width: inherit !important;\n}\n\n.operations table thead tr th:nth-child(3) {\n  /*width: 5%;*/\n}\n\n.operations table thead tr th:nth-child(4) {\n  /*width: 10%;*/\n}\n\n.operations table thead tr th:nth-child(5),\n.recettes table thead tr th:nth-child(5) {\n  /*width: 10%;*/\n}\n\n.operations table thead tr th:nth-child(6) {\n  /*width: 10%;*/\n}\n\n.operations table thead tr th:nth-child(7),\n.operations table thead tr th:nth-child(8) {\n  /*width: 13.5%;*/\n}\n\n.operations table thead tr th:nth-child(7) .icons > div,\n.operations table thead tr th:nth-child(8) .icons > div {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.operations table thead tr th:nth-child(7),\n.operations table thead tr th:nth-child(8),\n.operations table thead tr th .text span {\n  font-style: normal;\n  font-weight: bold;\n  /*font-size: 18px;*/\n  line-height: 30px;\n  color: #ffffff;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.operations table thead tr th .label {\n  font-style: normal;\n  font-weight: bold;\n  /*font-size: 18px;*/\n  line-height: 30px;\n  color: #ffffff;\n}\n\n.operations table thead tr th .text svg {\n  font-size: 35px;\n}\n\n.operations table thead tr th .text > *:nth-child(2) {\n  transform: translate(-2px, -3px);\n}\n\n.operations table thead tr th .text svg:last-child {\n  transform: translate(-80%, 13%);\n}\n\n.operations table thead tr th .icons > div {\n  position: absolute;\n  top: 0;\n  left: 0px;\n}\n\n.operations table thead tr th .icons p {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 19px;\n  color: #ffffff;\n  padding-left: 21px;\n  position: relative;\n}\n\n.operations table thead tr th .icons p span {\n  content: \"+\";\n  background-color: white;\n  border: 1px solid #8a46fb;\n  color: #8a46fb;\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  text-align: center;\n  border-radius: 50%;\n  line-height: 16px;\n  font-size: 20px;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.operations table thead tr th .icons ul li {\n  margin-right: 5px;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  text-align: center;\n  line-height: 24px;\n  font-size: 12px;\n  box-sizing: content-box;\n  color: white;\n}\n\n.operations table thead tr th .icons ul li.green {\n  background: #09bd72;\n  border: 2px solid #09bd72;\n}\n\n.operations table thead tr th .icons ul li.orange {\n  background: #f87c22;\n  border: 2px solid #f87c22;\n}\n\n.operations table thead tr th .icons ul li.red {\n  background: #fd5353;\n  border: 2px solid #fd5353;\n}\n\n.operations table thead tr th .icons ul li.green-border {\n  background: white;\n  color: #09bd72;\n  border: 2px solid #09bd72;\n}\n\n.operations table thead tr th .icons ul li.orange-border {\n  background: white;\n  color: #f87c22;\n  border: 2px solid #f87c22;\n}\n\n.operations table thead tr th .icons ul li.red-border {\n  background: white;\n  color: #fd5353;\n  border: 2px solid #fd5353;\n}\n\n.operations table tbody.sub-rows {\n  display: none;\n  opacity: 0;\n  transition: opacity 1s 1s ease-in-out;\n}\n\n.operations table tbody.show-sub-rows {\n  display: table-row-group;\n  opacity: 1;\n}\n\n.operations table tbody tr td,\n.msg-table table tbody tr td {\n  height: 90px;\n}\n\n.operations table tbody tr td:nth-child(2) h4 {\n  font-style: normal;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 19px;\n  color: #fd5353;\n}\n\n.operations table tbody tr td:nth-child(2) h4 span {\n  margin-right: 5px;\n}\n\n.operations table tbody tr td:nth-child(2) h3 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #000000;\n}\n\n.operations table tbody tr td:nth-child(2) > div {\n  width: 100%;\n}\n\n/*.operations table tbody tr td:nth-child(2) > div > div{*/\n/*    margin-left: auto;*/\n/*    margin-right: 30px;*/\n/*}*/\n.p-0 {\n  padding: 0 !important;\n}\n\n.rounded-r-none {\n  border-top-right-radius: 0px !important;\n}\n\n.except-last-td > td.actions,\n.except-last-th > th.actions {\n  background-color: white;\n}\n\n.messages .list-msg .add,\n.btn-add {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 55px;\n  height: 55px;\n  line-height: 48px;\n  text-align: center;\n  font-size: 46px;\n  background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);\n  border-radius: 20px;\n  color: white;\n  transform: translate(22%, -50%);\n}\n\n.operations table tbody tr td:nth-child(2) svg,\n.operations table tbody tr td:nth-child(2) > div {\n  align-self: center;\n}\n\n.operations table tbody tr td:nth-child(2) > div svg {\n  margin-left: 25px;\n  margin-top: -2px;\n  cursor: pointer;\n}\n\n.operations table tbody tr td:nth-child(3) > div {\n  position: relative;\n  display: inline-block;\n}\n\n.operations table tbody tr td:nth-child(3) svg {\n  color: #717579;\n  font-size: 35px;\n}\n\n.operations table tbody tr td:nth-child(3) span.unread {\n  background: #ff9d42;\n}\n\n.operations table tbody tr td:nth-child(3) span.read {\n  background: #818181;\n}\n\n.operations table tbody tr td .top-icon {\n  position: absolute;\n  border: 3px solid #fbfbfb;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  color: #ffffff;\n  width: 28px;\n  height: 28px;\n  right: 0;\n  top: 0;\n  border-radius: 50%;\n  text-align: center;\n  transform: translate(50%, -50%);\n  line-height: 23px;\n}\n\n.operations table tbody tr td:nth-child(6) span:nth-child(2) {\n  font-style: normal;\n  font-weight: 300;\n  /*font-size: 16px;*/\n  line-height: 22px;\n  color: #b3b3b3;\n  margin-left: 10px;\n}\n\n.operations table tbody tr td:nth-child(7) svg {\n  color: #818181;\n  font-size: 30px;\n}\n\n.operations table tbody tr td:nth-child(7) span {\n  width: 20px;\n  height: 20px;\n  transform: translate(15%, -50%);\n}\n\n.operations table tbody tr td:nth-child(7) span.green {\n  background-color: #09bd72;\n}\n\n.operations table tbody tr td:nth-child(7) span.orange {\n  background-color: #f87c22;\n}\n\n.operations table tbody tr td:nth-child(7) span.red {\n  background-color: #fd5353;\n}\n\n.operations table tbody tr td:nth-child(8) > div {\n  cursor: pointer;\n}\n\n.operations table tbody tr td:nth-child(8) > div span {\n  color: white;\n}\n\n.operations table tbody tr td:nth-child(8) > div.icon {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-radius: 50%;\n  margin: 0 auto;\n}\n\n.operations table tbody tr td:nth-child(8) > div.text {\n  background: #fd5353;\n  border-radius: 20px;\n  width: 100px;\n  height: 40px;\n  line-height: 40px;\n  margin: 0 auto;\n}\n\n.operations table tbody tr td:nth-child(8) > div.green {\n  background: #09bd72;\n}\n\n.operations table tbody tr td:nth-child(8) > div.orange {\n  background: #f87c22;\n}\n\n.operations table tbody tr td:nth-child(8) > div.red {\n  background: #fd5353;\n}\n\n.operations table tbody tr td:nth-child(8) svg {\n  color: white;\n}\n\n.operations tbody.sub-rows tr:last-child {\n  border-bottom: none;\n}\n\n.operations tbody.sub-rows tr:last-child td:first-child {\n  border-bottom-left-radius: 20px;\n}\n\n.operations tbody.sub-rows tr:last-child td:last-child {\n  border-bottom-right-radius: 20px;\n}\n\n.operations tbody.sub-rows tr:last-child td {\n  border: none;\n}\n\n.operations .btn-add a {\n  background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);\n  border-radius: 20px;\n  height: 60px;\n  width: 60px;\n  display: block;\n  text-align: center;\n  line-height: 51px;\n  font-size: 51px;\n  color: white;\n  margin-left: auto;\n  margin-top: 14px;\n  cursor: pointer;\n}\n\n.recette {\n  margin-top: 40px;\n  box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);\n  border-radius: 20px;\n  overflow-y: auto;\n}\n\n.recette .parent-recette {\n  min-width: 1100px;\n}\n\n.recette .title {\n  background: #30006d;\n  padding: 30px;\n  border-radius: 20px 20px 0 0;\n  overflow: hidden;\n}\n\n.recette h2 {\n  font-style: normal;\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 33px;\n  color: #ffffff;\n}\n\n.recette .table {\n  background: #ffffff;\n  width: 100%;\n}\n\n.recette .open {\n  box-shadow: 0px 3px 6px rgb(86 86 86 / 25%);\n  border-radius: 0px 0px 20px 20px;\n  padding-bottom: 17px;\n}\n\n.recette .table .summary {\n  border-bottom: 1px solid #d7d7d7;\n}\n\n.recette .table .border-0 {\n  border: none !important;\n}\n\n.recette .table .summary svg {\n  cursor: pointer;\n}\n\n.recette .table .summary ul {\n  margin: 20px 30px;\n}\n\n.recette .table .summary ul li {\n  flex: 1 1 0px;\n}\n\n.recette .table:nth-child(odd) {\n  background-color: #f2f5ff;\n}\n\n.recette .table .table-title {\n  margin: 20px 30px 16px;\n}\n\n.recette .table .hide {\n  display: none;\n}\n\n.recette .table .table-title h4 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #717579;\n}\n\n.recette .table .table-title svg {\n  margin: 0 0 0 auto;\n  cursor: pointer;\n}\n\n.recette .table thead tr {\n  text-align: left;\n  border-bottom: 1px solid #d7d7d7;\n}\n\n.recette .table thead tr th {\n  padding-bottom: 16px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 25px;\n  color: #171b1e;\n}\n\n.recette .table tr td {\n  padding-top: 16px;\n  width: calc(100% / 12);\n}\n\n.recette .table tr th:first-child,\n.recette .table tr td:first-child {\n  padding-left: 30px;\n}\n\n/* START RESPONSIVE PART */\n\n@media (max-width: 1300px) {\n  .dashboard .general-stats .item {\n    /*flex: none;*/\n  }\n\n  .dashboard .general-stats .item:nth-child(odd) {\n    margin-left: 0;\n  }\n\n  .dashboard .general-stats .item:nth-child(even) {\n    margin-right: 0;\n  }\n\n  .graphs .item {\n    width: 100% !important;\n  }\n  .chartClass {\n    width: 100% !important;\n  }\n  .parent-div {\n    padding-top: 46px;\n  }\n  .graphs {\n    position: relative;\n  }\n\n  .switchBtn {\n    position: absolute;\n    top: 0;\n    left: 30px;\n    width: auto;\n  }\n}\n\n@media (max-width: 1400px) {\n  .resize-text {\n    font-size: 12px !important;\n  }\n\n  .dashboard .general-stats .item {\n    height: 258px;\n  }\n\n  .dashboard .general-stats .item h1 {\n    margin-bottom: 3px;\n  }\n\n  .dashboard .general-stats .item ul li {\n    margin-bottom: 0;\n  }\n\n  .dashboard .general-stats .item ul li:before {\n    margin-right: 5px;\n    margin-bottom: 6px;\n  }\n\n  .dashboard .general-stats .item ul li span {\n    /*font-size: 14px;*/\n  }\n\n  .dashboard .general-stats .item ul li span:last-child {\n    /*font-size: 15px;*/\n  }\n\n  .operations table thead tr th .icons ul li.green-border {\n    background: white;\n    color: #09bd72;\n    border: 2px solid #09bd72;\n  }\n  .operations table thead tr th .icons ul li {\n    margin-right: 5px;\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    line-height: 16px;\n    text-align: center;\n    font-size: 8px;\n    box-sizing: content-box;\n  }\n}\n\n@media (max-width: 1550px) {\n  .dashboard .general-stats .item ul li:before {\n    margin-right: 5px;\n  }\n}\n\n@media (max-width: 1000px) {\n  .dashboard .general-stats .item {\n    margin-right: 0.5em !important;\n    margin-left: 0.5em !important;\n  }\n}\n\n@media (max-width: 700px) {\n  .graphs {\n    padding: 0;\n  }\n\n  .graphs .item {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 760px) {\n  .none-mobile {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  /*.client-info{*/\n  /*    padding-left: inherit;*/\n  /*}*/\n}\n\n@media (max-width: 999px) {\n  .client-info {\n    padding-left: inherit;\n  }\n}\n\n@media (min-width: 1000px) {\n  #derouler {\n    padding-left: 367px;\n  }\n}\n\n@media (max-width: 1600px) {\n  .periode-aff {\n    flex-wrap: wrap;\n  }\n\n  .periode-aff > div {\n    width: 100%;\n    margin-right: 0 !important;\n    /*margin-bottom: 10px;*/\n  }\n\n  .periode-aff .uppercase {\n    margin-right: 5px;\n  }\n}\n\n.react-resizable-handle {\n\tbottom: auto !important;\n\tright: -15px !important;\n\tbackground-size: cover;\n}\n\n#resizable-element div:first-child::-webkit-scrollbar-thumb {\n\tbackground-color: #5a45aa80;\n\tborder: 4px solid transparent;\n\tborder-radius: 0.5rem;\n\tbackground-clip: padding-box;\n}\n\n#resizable-element div:first-child::-webkit-scrollbar {\n\twidth: 18px;\n}\n\n.export-account .radio-label {\n  padding: .7rem 2rem;\n  border-radius: .5rem;\n  color: #FFF;\n  cursor: pointer;\n  font-weight: bold;\n  background-color: rgb(162 143 235 / var(--tw-bg-opacity));\n}\n\n.export-account input[type=\"radio\"] {\n  display: none;\n}\n\n.export-account input[type=\"radio\"]:checked + .radio-label {\n  background-color: rgb(101 38 158 / var(--tw-bg-opacity));\n  color: white;\n  font-weight: bold;\n}\n\ntable.operations-table > tbody > tr,\ntable.documents-table > tbody > tr {\n  background-color: transparent;\n  transition: background-color 2s ease;\n}\n\ntable.operations-table > tbody > tr.highlighted-row,\ntable.documents-table > tbody > tr.highlighted-row {\n  background-color: lightyellow !important;\n}\n\n#affectation-operation tfoot.ocr-reprocessed,\n#affectation-operation tfoot.ocr-reprocessed input,\ntable.affectations-piece tfoot.ocr-reprocessed, \ntable.affectations-piece tfoot.ocr-reprocessed input {\n  background: #e2fbbc;\n}\n\n#affectation-operation tfoot.ocr-reprocessed tr td,\ntable.affectations-piece tfoot.ocr-reprocessed tr td {\n  color: rgb(29 153 74);\n  font-weight: bold;\n}\n\n.scan-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 255, 0, 0.1) 0%,\n    rgba(0, 255, 0, 0.4) 50%,\n    rgba(0, 255, 0, 0.1) 100%\n  );\n  animation: scan 2s linear infinite;\n}\n\n@keyframes scan {\n  0% {\n    top: -100%;\n  }\n  100% {\n    top: 100%;\n  }\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.is-corrected {\n  font-weight: bold;\n  color: #2d986c;\n}\n\n/* START: Custom Checkbox Type 1 */\n.checkbox-type1 input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkbox-type1 .checkbox-icon {\n  width: 23px;\n  height: 23px;\n  background: #FFF;\n  border: 2px solid #30006D;\n  border-radius: 8px;\n  display: inline-block;\n  position: relative;\n  margin-right: 8px;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.checkbox-type1 .checkbox-icon .checkmark {\n  position: absolute;\n  top: -3px;\n  right: -5px;\n  display: none;\n}\n\n.checkbox-type1 input[type=\"checkbox\"]:checked + .checkbox-icon .checkmark {\n  display: block;\n}\n/* END: Custom Checkbox Type 1 */\n\n.documents-suggestions {\n  width: 65%;\n}\n\n.document-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.document-row .document {\n  flex: 1;\n  padding: .6rem;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  background: rgb(242 245 255 / var(--tw-bg-opacity));\n}\n\n.document-row table {\n  width: 100%;\n  table-layout: fixed;\n  box-shadow: none !important;\n}\n\n.document-row table thead tr td {\n  font-size: 14px;\n  color: #717579;\n}\n\n.document-row table thead tr td.date,\n.document-row table thead tr td.label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.document-row table thead tr td.date {\n  width: 120px;\n}\n\n.document-row table thead tr td.label {\n  width: 270px;\n}\n\n.document-row table tr td {\n  padding: 4px 7px !important;\n}\n\n.document-row table tbody tr td {\n  font-size: 16px;\n} \n\n.document-row table tbody tr td span.rate {\n  color: #B3B3B3;\n}\n\n.document-row table tbody .categ,\n.affect table.affectations-piece tbody .categ {\n  color: #818181;\n  font-size: 12px;\n  font-weight: 500 !important;\n}\n\n.documents-suggestions button.other-documents {\n  width: 186px;\n  height: 47px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  padding: 7px;\n  justify-content: space-evenly;\n  background: #F2F5FF;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
